import { /* HttpErrorResponse, HttpResponse,*/ HttpInterceptorFn } from "@angular/common/http";

export const mockInterceptor: HttpInterceptorFn = (req, next) => {
  /* if (req.urlWithParams.includes("/notification/categories")) {
    const categories: NotificationCategory[] = notificationCategories;
    return of(
      new HttpResponse({
        status: 200,
        body: categories,
      })
    );
  } else if (req.urlWithParams.includes("api/v2/notification")) {
    // Extract query parameter
    const onlyUnread = req.params.get("onlyUnread");
    const notificationCategory = req.params.get("notificationCategory") as NOTIFICATION_CATEGORIES | null;
    const pageSize = Number(req.params.get("pagination[pageSize]") ?? 100);
    const total = 200;

    // Convert to boolean if needed
    const onlyUnreadBoolean = onlyUnread === "true" ? true : onlyUnread === "false" ? false : undefined;

    const resBody: CursorPaginationDto<Notification, { totalUnreadCount: number }> = {
      items: generateNotifications(pageSize, onlyUnreadBoolean, notificationCategory ?? undefined),
      total,
      meta: { totalUnreadCount: 43 },
    };
    return of(
      new HttpResponse({
        status: 200,
        body: resBody,
      })
    ).pipe(delay(2000));
  } */

  // if(req.urlWithParams.includes("/thiefProtection/alerts")){

  //   const url = new URL(req.urlWithParams);
  //   const page = Number(url.searchParams.get('page') ||1);
  //   const limit = Number(url.searchParams.get('limit') ||50);

  //   const allAlerts = generateMockAlerts(150);
  //   const startIndex = (page-1)*limit;
  //   const paginatedAlerts = allAlerts.slice(startIndex,startIndex+limit)

  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: {
  //         data: paginatedAlerts,
  //         pagination: {
  //           page,
  //           limit,
  //           total: allAlerts.length,
  //           totalPages: Math.ceil(allAlerts.length / limit),
  //         },
  //       },
  //     }),
  //   );
  // }
  // else if (req.urlWithParams.includes("/thief-protection/config/")) {
  //   if(req.urlWithParams.includes('245')){
  //     throwError(()=> new HttpErrorResponse({
  //       status:404,
  //       statusText:'Not found'
  //     }))
  //   } else {
  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: THIEF_PROTECTION_CONFIG,
  //       })
  //     );
  //   }
  // }
  // if (
  //   req.urlWithParams.includes(
  //     "timeseries?assetId=740&assetType=GATE_SYSTEM&keys=energy_loss,energy_loss_normal_operation&startTs=1730415600000"
  //   )
  // ) {

  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: ENERGY_TOOL_DATA_MONTH,
  //     })
  //   );
  // } else if (
  //   req.urlWithParams.includes(
  //     "timeseries?assetId=740&assetType=GATE_SYSTEM&keys=energy_loss&startTs=1732489200000&endTs=1733093999999"
  //   )
  // ) {
  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: ENERGY_TOOL_DATA_WEEK,
  //     })
  //   );
  // }
  // if (req.url.startsWith("/assets")) {
  //   const assetType = req.params.get("assetType");
  //   const parentId = req.params.get("parentId");
  //   if (assetType && parentId) {
  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: getChildernAssetData(assetType, parentId),
  //       })
  //     );
  //   }
  // } else if (req.url.startsWith("/asset/")) {
  //   const assetId = req.url.split("/")[2];

  //   const assetType = req.params.get("assetType");
  //   if (assetId && assetType) {
  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: getDetailsData(assetType, assetId),
  //       })
  //     );
  //   }
  // } else if (req.url.startsWith("/systemAlert")) {
  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: SYS_ALERTS,
  //     })
  //   );
  // } else
  // if (req.url.startsWith("/programs")) {
  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: PROGRAMS,
  //     })
  //   );
  // } else if (req.url.startsWith("/programDetails")) {
  //   const programId = req.url.split("/")[2];

  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: PROGRAM_DETAILS[programId],
  //     })
  //   );
  // } else if (req.url.startsWith("/ruleChain/")) {
  //   const programId = req.url.split("/")[2];

  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: PROGRAM_DETAILS[programId],
  //     })
  //   );
  // } else if (req.url.startsWith("/ruleChain")) {
  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: PROGRAMS,
  //     })
  //   );
  // }
  // else if (
  //   req.urlWithParams.startsWith(environment.baseUrl + "/notification")
  // ) {
  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: NOTIFICATIONS_REPSONSE,
  //     })
  //   );
  // }
  // else if (
  //   req.url.startsWith("https://dev.botevo.com/api/v2/controllerCatalogItem")
  // ) {
  //   const catalogType = req.params.get("catalogType");
  //   const parentId = req.params.get("parentId");
  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: getControllerCatalogData(catalogType, parentId),
  //     })
  //   );
  // }
  // else if (req.url.startsWith("/faultLists")) {
  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: FAULT_LIST_EXAMPLE,
  //     })
  //   );
  // }
  // else if (
  //   req.url.startsWith("https://dev.botevo.com/api/v1/gateCatalogItem")
  // ) {
  //   const catalogType = req.params.get("catalogType");
  //   const parentId = req.params.get("parentId");
  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: getGateCatalogData(catalogType, parentId),
  //     })
  //   );
  // }
  // else if (req.url.startsWith("/componentTypes")) {
  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: COMPONENT_TYPES_EXAMPLE,
  //     })
  //   );
  // }
  // else if (req.url.startsWith("/gateComponents")) {
  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: GATE_COMPONENTS_LIST_EXAMPLE,
  //     })
  //   );
  // }
  return next(req);
};
